import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "disputeWrap",
    "disputeForm",
    "disputeSessionTitle",
    "locationWrap",
    "locationAddress",
    "locationMap",
    "locationMapsLink",
    "supportWrap",
    "workoutExercisesWrap",
    "workoutExercisesTitle",
    "workoutExercisesBody",
  ]

  openDispute(event) {
    event.preventDefault()
    const el = event.currentTarget
    const url = el.dataset.submitUrl
    const csrfToken = el.dataset.csrfToken
    if (!url || !this.hasDisputeFormTarget || !this.hasDisputeWrapTarget) return

    this.disputeFormTarget.setAttribute("action", url)
    this.setFormCsrfToken(this.disputeFormTarget, csrfToken)

    if (this.hasDisputeSessionTitleTarget) {
      this.disputeSessionTitleTarget.textContent = el.dataset.sessionTitle || ""
    }

    const reason = this.disputeFormTarget.querySelector('[name="dispute_reason"]')
    const details = this.disputeFormTarget.querySelector('[name="dispute_details"]')
    if (reason) reason.selectedIndex = 0
    if (details) details.value = ""

    this.disputeWrapTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  setFormCsrfToken(form, token) {
    if (!token) return
    let input = form.querySelector('input[name="authenticity_token"]')
    if (!input) {
      input = document.createElement("input")
      input.type = "hidden"
      input.name = "authenticity_token"
      form.appendChild(input)
    }
    input.value = token
  }

  closeDispute() {
    if (!this.hasDisputeWrapTarget) return
    this.disputeWrapTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  openLocation(event) {
    event.preventDefault()
    if (!this.hasLocationWrapTarget) return
    const el = event.currentTarget
    const addr = el.dataset.address || ""

    if (this.hasLocationAddressTarget) {
      this.locationAddressTarget.textContent = addr
    }
    if (this.hasLocationMapsLinkTarget) {
      this.locationMapsLinkTarget.href = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(addr)}`
    }

    const lat = parseFloat(el.dataset.lat || "")
    const lng = parseFloat(el.dataset.lng || "")

    if (this.hasLocationMapTarget) {
      if (Number.isFinite(lat) && Number.isFinite(lng)) {
        const pad = 0.02
        const bbox = `${lng - pad},${lat - pad},${lng + pad},${lat + pad}`
        this.locationMapTarget.src = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat}%2C${lng}`
        this.locationMapTarget.classList.remove("hidden")
      } else {
        this.locationMapTarget.removeAttribute("src")
        this.locationMapTarget.classList.add("hidden")
      }
    }

    this.locationWrapTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  closeLocation() {
    if (!this.hasLocationWrapTarget) return
    this.locationWrapTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
    if (this.hasLocationMapTarget) {
      this.locationMapTarget.src = "about:blank"
    }
  }

  openSupport(event) {
    event.preventDefault()
    if (!this.hasSupportWrapTarget) return
    this.supportWrapTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  closeSupport() {
    if (!this.hasSupportWrapTarget) return
    this.supportWrapTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  openWorkoutExercises(event) {
    event.preventDefault()
    event.stopPropagation()
    if (!this.hasWorkoutExercisesWrapTarget || !this.hasWorkoutExercisesBodyTarget) return
    const el = event.currentTarget
    const templateId = el.dataset.templateId
    const workoutTitle = el.dataset.workoutTitle || "Programmed workout"
    if (!templateId) return
    const tmpl = document.getElementById(templateId)
    if (!tmpl) return
    if (this.hasWorkoutExercisesTitleTarget) {
      this.workoutExercisesTitleTarget.textContent = workoutTitle
    }
    this.workoutExercisesBodyTarget.replaceChildren()
    this.workoutExercisesBodyTarget.appendChild(tmpl.content.cloneNode(true))
    this.workoutExercisesWrapTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  closeWorkoutExercises() {
    if (!this.hasWorkoutExercisesWrapTarget) return
    this.workoutExercisesWrapTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
    if (this.hasWorkoutExercisesBodyTarget) {
      this.workoutExercisesBodyTarget.replaceChildren()
    }
  }
}
